import { render, staticRenderFns } from "./XAxis.vue?vue&type=template&id=28888776&scoped=true&"
import script from "./XAxis.vue?vue&type=script&lang=js&"
export * from "./XAxis.vue?vue&type=script&lang=js&"
import style0 from "./XAxis.vue?vue&type=style&index=0&id=28888776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28888776",
  null
  
)

export default component.exports